import $apiPrivate from 'api/apiPrivate'

const getAlert = async () => {
  const response = await $apiPrivate.get('/user/alert');
  return response
}

const setLanguage = async (language) => {
  const response = await $apiPrivate.post('/user/change_language', { language });
  return response
}

const getAvailablePages = async () => {
  const response = await $apiPrivate.get('/front/permissions');
  return response
}

export default {
  getAlert,
  setLanguage,
  getAvailablePages,
}